import React from 'react';
import { useFeatureContext } from '@veeam/core';
import { DialogActions, ACTION_VIEW } from "../Dialog";
export var WizardActions = React.memo(function (_a) {
    var loading = _a.loading, prev = _a.prev, next = _a.next, skip = _a.skip, done = _a.done, cancel = _a.cancel;
    var t = useFeatureContext().t;
    return (React.createElement(DialogActions, { loading: loading, primary: [
            !prev.disabled && {
                id: 'previous',
                text: prev.title || t('wizard|actions|previous') || 'Previous',
                view: ACTION_VIEW.alternate,
                onClick: prev.didSelect
            },
            !next.disabled && {
                id: 'next',
                text: next.title || t('wizard|actions|next') || 'Next',
                view: ACTION_VIEW.primary,
                onClick: next.didSelect
            },
            !skip.disabled && {
                id: 'skip',
                text: skip.title || t('wizard|actions|skip') || 'Skip',
                view: ACTION_VIEW.primary,
                onClick: skip.didSelect
            },
            !done.disabled && {
                id: 'done',
                text: done.title || t('wizard|actions|done') || 'Finish',
                view: ACTION_VIEW.primary,
                onClick: done.didSelect
            },
            !cancel.disabled && {
                id: 'cancel',
                text: cancel.title || t('wizard|actions|cancel') || 'Cancel',
                view: 'secondary',
                onClick: cancel.didSelect
            }
        ].filter(Boolean) }));
});
//# sourceMappingURL=WizardActions.js.map